import { render } from "./user.vue?vue&type=template&id=41da2d94&scoped=true"
const script = {}

import "./user.vue?vue&type=style&index=0&id=41da2d94&lang=less"
import "./user.vue?vue&type=style&index=1&id=41da2d94&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41da2d94"]])

export default __exports__